import React from 'react'

const ChannelIcon = () => (
    <svg width="89" height="52" viewBox="0 0 89 52" xmlns="http://www.w3.org/2000/svg">
        <g id="Mark-3" fill="none" fillRule="evenodd">
            <g
                id="Channels-Value-View-Mode-Dashboard-Empty"
                transform="translate(-111 -333)"
                stroke="#868695"
                strokeWidth="2"
            >
                <g id="Group-4" transform="translate(111 337)">
                    <g id="Group-3">
                        <polyline
                            id="Stroke-1"
                            points="0 20.4512195 26.9069767 20.4512195 40.6212558 0 40.6212558 43 53.8139535 14.8087805 57.1793953 20.4512195 89 20.4512195"
                        />
                    </g>
                </g>
            </g>
        </g>
    </svg>
)

export default ChannelIcon
